// npm packages
import React, { useEffect, useState, Fragment, useContext } from "react";
import * as moment from "moment";

// custom pages
import Context from "context/context";
import reportAPI from "apis/panel/reports/reports";
import "../Reports.css";

// material ui
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Button from "@mui/material/Button";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import ReplayIcon from "@mui/icons-material/Replay";
import { styled } from "@mui/system";
import { FormControl, MenuItem, Select } from "../../../../../node_modules/@mui/material/index";

const CustomCheckbox = styled(Checkbox)({
  color: " #0056B2",
  "&.Mui-checked": {
    color: " #0056B2",
  },
});

export default function EmployeeLeavesSummary({ setDisableDropdown }) {
  const { dispatch } = useContext(Context);

  const { getEmployeeLeavesSummaryAPI,getAllDepartmentsAPI} =
    reportAPI();

  const [checkedList, setCheckedList] = useState(new Set());
  const [allDept, setAllDept] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [year, setYear] = useState(new Date());
  const [employmentStatus,setEmploymentStatus] = useState('Active')
  const [submitClicked, setSubmitClicked] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const [reset, setReset] = useState(false);

  const handleReset = () => {
    setYear(null);

    setSelectAll(true);
    setReset(false);
    handleSelectAll();
    setEmploymentStatus('Active')
  };

  const handleExport = async () => {
    setSubmitClicked(true);
    if (!year ) {
      setSubmitted(false);
      return;
    }
    let body = {};

    const selectedDeptArray = Array.from(checkedList);
    if (selectedDeptArray?.length == 0) {
      setSubmitted(false);

      return;
    }

    const date = new Date(year); 
    const selectedYear = date.getFullYear();
    body = {
      year: selectedYear.toString(),
     
      deptIds: selectedDeptArray,
      employmentStatus:employmentStatus
    };

    dispatch({ type: "SET_LOADING", payload: true });
    setDisableDropdown(true);
    await getEmployeeLeavesSummaryAPI(body);
    setSubmitClicked(false);
    setSubmitted(false);
    setDisableDropdown(false);
    dispatch({ type: "SET_LOADING", payload: false });
  };

  const handleChange = (deptId) => {
    setCheckedList((prevList) => {
      const newCheckedList = new Set(prevList);
      if (newCheckedList.has(deptId)) {
        newCheckedList.delete(deptId);
      } else {
        newCheckedList.add(deptId);
      }
      if (newCheckedList.size === allDept.length) {
        setSelectAll(true);
        setReset(false);
      } else {
        setSelectAll(false);
        setReset(true);
      }
      return newCheckedList;
    });
  };

  const handleSelectAll = () => {
    if (checkedList.size === allDept.length) {
      setCheckedList(new Set());
      setSelectAll(false);
      setReset(true);
    } else {
      const newCheckedList = new Set(
        allDept.map((dept) => dept?.department_id)
      );
      setCheckedList(newCheckedList);
      setSelectAll(true);
      setReset(false);
    }
  };

  const getAllDepartments = async () => {
    dispatch({ type: "SET_LOADING", payload: true });
    const res = await getAllDepartmentsAPI();

    const departments = res?.data?.departments;
    setCheckedList(
      new Set(departments.map((department) => department.department_id))
    );

    setAllDept(departments);

    setSelectAll(true);
    dispatch({ type: "SET_LOADING", payload: false });
  };

  const handleYear = async (value) => {
    setYear(value);
    setReset(true);
  };

  

  useEffect(() => {
    getAllDepartments();
  }, []);

   const statusLabels = {
  Active: "Active",
  Inactive: "In Active",
};

  return (
    <Fragment>
      <Grid container spacing={4} sx={{ mt: 2 }}>
        <Grid item xs={6} sm={6} md={3} lg={4}>
          <Box className="labelproj">
           Year <span style={{ color: "red" }}>*</span>
          </Box>
          <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
            <DatePicker
              id="year"
              name="year"
              sx={{ width: "100%" }}
              views={['year']}
              format="yyyy"
              renderInput={(params) => <TextField {...params} fullWidth />}
              maxDate={new Date()}
              value={year}
              onChange={(newValue) => handleYear(newValue)}
            />
          </LocalizationProvider>
          {submitClicked && !year && (
            <Box sx={{ color: "red", fontSize: "13px" }}>
              <span>*</span> This Field is Required
            </Box>
          )}
        </Grid>
           <Grid item xs={6} sm={6} md={3} lg={4}>
          <Box className="labelproj">Employment Status
            <span style={{ color: "red" }}>*</span>
          </Box>
          <FormControl fullWidth>
            <Select
              labelId="vra-label-2"
              id="vra-select-2"
              name="vra-select-2"
              // multiple
              displayEmpty
              value={employmentStatus}
              onChange={(e) => {
                setEmploymentStatus(e.target.value);
              }}
              inputProps={{ "aria-label": "Timesheet Status" }}
                renderValue={(selected) => {
        if (!selected) {
          return <em>Select Status</em>;
        }
       return statusLabels[selected];
      }}
            >
              
              <MenuItem value={'Active'}>Active</MenuItem>
              <MenuItem value={'Inactive'}>In Active</MenuItem>
            
            </Select>
          </FormControl>
        </Grid>
        
       {/* <Grid item xs={6} sm={6} md={3} lg={4}>
  <Box className="labelproj">
    Month <span style={{ color: "red" }}>*</span>
  </Box>
  <LocalizationProvider dateAdapter={AdapterDateFns}>
    <DatePicker
      id="month"
      name="month"
      sx={{ width: "100%" }}
      // Show only month view (optionally + year)
      views={['month']}                        // <— only month
      openTo="month"                           // default opens the month view
      inputFormat="MM"                         // show month (you could also use "MM/yyyy" if you need year displayed)
      maxDate={new Date()}
      value={month}                            // rename `year` to `month` perhaps
      // onChange={(newValue) => handleMonth(newValue)}
      renderInput={(params) => <TextField {...params} fullWidth />}
    />
  </LocalizationProvider>
  {submitClicked && !month && (
    <Box sx={{ color: "red", fontSize: "13px" }}>
      <span>*</span> This Field is Required
    </Box>
  )}
</Grid> */}


       
      </Grid>
      <Grid container spacing={4} sx={{ mt: 2 }}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Box display="flex" alignItems="center">
            <FormControlLabel
              className="labelproj"
              control={
                <CustomCheckbox
                  checked={selectAll}
                  onChange={handleSelectAll}
                />
              }
              label={
                <>
                  <span
                    style={{
                      fontFamily: "Inter",
                      fontSize: "18px",
                      fontWeight: "600",
                    }}
                  >
                    Department Name
                  </span>
                  <span style={{ color: "red" }}>*</span>
                </>
              }
            />
          </Box>
          {submitClicked && checkedList.size == 0 && (
            <Box sx={{ marginTop: "10px", color: "red", fontSize: "13px" }}>
              <span>*</span> This Field is Required
            </Box>
          )}
        </Grid>

        {allDept &&
          allDept.length > 0 &&
          allDept.map((dept, index) => (
            <Grid
              key={dept?.department_id}
              sx={{ height: "60px" }}
              item
              xs={12}
              sm={5}
              md={5}
              lg={5}
            >
              <Box sx={{ display: "flex", ml: 3 }}>
                <FormControlLabel
                  label={dept?.department_name}
                  control={
                    <CustomCheckbox
                      checked={checkedList.has(dept?.department_id)}
                      onChange={() => handleChange(dept?.department_id)}
                    />
                  }
                />
              </Box>
            </Grid>
          ))}
      </Grid>
      <Grid></Grid>

      <Grid container>
        <Grid item xs={12} style={{ textAlign: "right", padding: "20px 0px" }}>
          {reset && (
            <Button
              className="reset-btn"
              component="label"
              variant="contained"
              tabIndex={-1}
              startIcon={
                <ReplayIcon style={{ fontSize: 30, verticalAlign: "middle" }} />
              }
              onClick={handleReset}
            >
              Reset
            </Button>
          )}
          <Button
            className="download-btn"
            startIcon={
              <DownloadForOfflineIcon
                style={{ fontSize: 30, verticalAlign: "middle" }}
              />
            }
            onClick={handleExport}
          >
            Export
          </Button>
        </Grid>
      </Grid>
    </Fragment>
  );
}
